import mapStyles from "./MapStyles.js";

function formatParams(mapsConfig) {
  const configKeys = Object.keys(mapsConfig);

  return configKeys
    .map(function (key, index) {
      let params = key + "=" + mapsConfig[key];

      if (index < configKeys.length - 1) {
        // the last one
        params = params + "&";
      }

      return params;
    })
    .join("");
}

function isColor(value) {
  return /^#[0-9a-f]{6}$/i.test(value.toString());
}

function toColor(value) {
  return "0x" + value.slice(1);
}

function googleMapsStyleFormat(jsonString) {
  const items = [];

  const separator = "|";

  var json;
  try {
    json = JSON.parse(jsonString);
  } catch (e) {
    throw new Error(e);
  }

  items.length = 0;

  for (var i = 0; i < json.length; i++) {
    var item = json[i],
      hasFeature = item.hasOwnProperty("featureType"),
      hasElement = item.hasOwnProperty("elementType"),
      stylers = item.stylers,
      target = "",
      style = "";

    if (!hasFeature && !hasElement) {
      target = "feature:all";
    } else {
      if (hasFeature) {
        target = "feature:" + item.featureType;
      }
      if (hasElement) {
        target = target ? target + separator : "";
        target += "element:" + item.elementType;
      }
    }

    for (var s = 0; s < stylers.length; s++) {
      var styleItem = stylers[s],
        key = Object.keys(styleItem)[0]; // there is only one per element

      style = style ? style + separator : "";
      style +=
        key +
        ":" +
        (isColor(styleItem[key]) ? toColor(styleItem[key]) : styleItem[key]);
    }

    items.push(target + separator + style);
  }

  return "&style=" + items.join("&style=");
}

export function getMapSrc(mapKey, lat, lng, zoom, width, height) {
  const mapsConfig = {
    // start map styles
    // ( this also works )
    /*
      style:[
        "element:labels|visibility:off",
        "element:geometry.stroke|visibility:off",
        "feature:landscape|element:geometry|saturation:-100",
        "feature:water|saturation:-100|invert_lightness:true"
      ],
      */
    //end map styles

    scale: 2,
    zoom: zoom,
    center: `${lat},${lng}`,

    // let the css figure this out
    size: `${parseInt(width)}x${parseInt(height)}`,

    format: "jpg",

    // TODO: change this to a signed key???
    key: mapKey,
  };

  let configParams = formatParams(mapsConfig);

  let cssParams = googleMapsStyleFormat(JSON.stringify(mapStyles));

  return `https://maps.googleapis.com/maps/api/staticmap?${configParams}${cssParams}`;
}
